import { Col, Row, Form, Breadcrumb, Tabs } from "antd";
import { useEffect, useState } from "react";
import GeneralInformation from "./GeneralInformation";
import ContactInformation from "./ContactInformation";
import AddressInformation from "./AddressInformation";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CancelBtn from "../UI/CancelButton/CancelBtn";
import { editSupplier, createSupplier } from "../../api/supplier";
import { supplierType } from "./types";
import { useMutation } from "react-query";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import PreviousButton from "../UI/PreviousButton/previousbutton";
import NextButton from "../UI/NextButton/nextbutton";
import AddEditButton from "../UI/AddEditButton/addeditbutton";
import AddEditModal from "../UI/ModalComponent/AddEditModal/addeditcomponent";
import { message } from "antd";
import { OptionProps } from "antd/es/mentions";
import { getCountriesDropdown } from "../../api/countries";
import { useQuery } from "react-query";

export interface Option {
  value: string;
  label: string;
}

function AddEditSupplier() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const supplier = location?.state?.supplier;
  const initialValues = location?.state?.initialValues;
  const loadingCountry = location?.state?.loadingCountry;
  const formatedCountry = location?.state?.formatedCountry;
  const formatedCurrency = location?.state?.formatedCurrency;
  const formatedContactType = location?.state?.formatedContactType;
  const [t] = useTranslation("common");
  const [key, setKey] = useState("1");
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const [FullName, setFullName] = useState(false);
  const [fullNameValid, setIsFullNameValid] = useState(false);
  const [fullNameErrorMessage, setFullNameErrorMessage] = useState("");
  const [ContactType, setContactType] = useState<any>(null);
  const [Currency, setCurrency] = useState<any>(null);
  const [phoneNumber, setPhoneNumber] = useState(false);
  const [, setError] = useState<any>();
  const [isCountrySelected, setIsCountrySelected] = useState<any>(null);
  const [supplierPhoneNumber] = useState<string[]>(
    supplier?.phone?.split("/") ?? ["+961", ""]
  );
  const [supplierMobileNumber] = useState<string[]>(
    supplier?.mobile?.split("/") ?? ["+961", ""]
  );
  const isEdit = () => {
    return !!id;
  };
  const [editStatus] = useState(isEdit());
  useEffect(() => {
    if (editStatus) {
      setIsFullNameValid(true);
      setContactType(true);
      setFullName(true);
      setCurrency(true);
      setIsCountrySelected(true);
      setPhoneNumber(true);
    }
  }, [editStatus]);

  const { mutate: mutateCreateUpdate, isLoading: isSaving } = useMutation(
    !isEdit() ? "createSupplier" : "editSupplier",
    !isEdit()
      ? (supplier: supplierType) => createSupplier(supplier)
      : (supplier: supplierType) => editSupplier(id, supplier),
    {
      onSuccess: (res) => {
        message.success("Complete successfully");
        navigate("/suppliers");
      },
      onError: (err: any) => {
        setError(err.response.data.errors[0].msg);
        message.error(err.response.data.errors[0].msg);
      },
    }
  );

  const HandleFinish = () => {
    const newsupplier = form.getFieldsValue();
    for (const key in newsupplier) {
      if (newsupplier[key] === undefined) {
        newsupplier[key] = null;
      } else if (
        typeof newsupplier[key] === "string" &&
        newsupplier[key].trim() === ""
      ) {
        newsupplier[key] = null;
      }
    }

    newsupplier.dob = dayjs(newsupplier.dob).format("MM/DD/YYYY HH:mm:ss");
    newsupplier.countryId = newsupplier.countryId ?? supplier?.country?.id;
    if (newsupplier.phone)
      newsupplier.phone = `${newsupplier.phoneAreaCode}/${newsupplier.phone}`;
    else newsupplier.phone = null;
    if (newsupplier.mobile)
      newsupplier.mobile = `${newsupplier.mobileAreaCode}/${newsupplier.mobile}`;
    else newsupplier.mobile = null;
    mutateCreateUpdate(newsupplier);
  };

  const [formatedCountryPhone, setFormatedCountryPhone] = useState<OptionProps[]>();

  useQuery("countries", getCountriesDropdown, {
    refetchOnWindowFocus: false,
    onSuccess: (res: any) => {
      const formattedCountryData = res.data?.map((country: any) => {
        return {
          value: country.areaCode,
          label: (
            <>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img style={{ width: 15, height: 15, marginRight: '0.3rem' }} src={`/flags/${country.abbreviation}.svg`} />
                {country.areaCode}
              </div>
            </>
          ),
        };
      });
      const uniqueFormattedCountryData = Array.from(
        new Set(formattedCountryData.map((country: any) => country.value))
      ).map((areaCode) =>
        formattedCountryData.find((country: any) => country.value === areaCode)
      );

      setFormatedCountryPhone(uniqueFormattedCountryData);
    },
  });

  const items = [
    {
      key: "1",
      label: `${t("general-information")}`,
      children: (
        <GeneralInformation
          formatedContactType={formatedContactType}
          formatedCurrency={formatedCurrency}
          setFullName={setFullName}
          setIsFullNameValid={setIsFullNameValid}
          setFullNameErrorMessage={setFullNameErrorMessage}
          fullNameErrorMessage={fullNameErrorMessage}
          setContactType={setContactType}
          setCurrency={setCurrency}
          isEdit={isEdit}
        />
      ),
    },
    {
      key: "2",
      label: `${t("address-information")}`,
      children: (
        <AddressInformation
          formatedCountry={formatedCountry}
          loadingCountry={loadingCountry}
          setIsCountrySelected={setIsCountrySelected}
        />
      ),
      disabled: !ContactType || !FullName || !Currency,
    },
    {
      key: "3",
      label: `${t("contact-information")}`,
      children: (
        <ContactInformation
          supplier={supplier}
          setPhoneNumber={setPhoneNumber}
          formatedCountryPhone={formatedCountryPhone}
        />
      ),
      disabled: !isCountrySelected,
    },
  ];
  const [activeTabLabel, setActiveTabLabel] = useState(items[0].label);

  const updateActiveTabLabel = (activeKey: string) => {
    const activeItem = items.find((item) => item.key === activeKey);
    if (activeItem) {
      setActiveTabLabel(activeItem.label);
    } else {
      setActiveTabLabel("");
    }
  };

  const onChange = (key: string) => {
    setKey(key);
    updateActiveTabLabel(key);
  };

  const handleNext = () => {
    const nextKey = (parseInt(key) + 1).toString();
    setKey(nextKey);
    updateActiveTabLabel(nextKey);
  };

  const handlePrevious = () => {
    const previousKey = (parseInt(key) - 1).toString();
    setKey(previousKey);
    updateActiveTabLabel(previousKey);
  };
  const isValid = dayjs(supplier?.dob, "MM/DD/YYYY HH:mm:ss").isValid();
  return (
    <>
      <Row>
        <Col offset={1} span={20}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("purchases")}</>,
              },
              {
                title: <Link to="/suppliers">{t("supplier-list")}</Link>,
              },
              {
                title: (
                  <>
                    {isEdit()
                      ? `${t("edit-supplier")}`
                      : `${t("add-supplier")}`}
                  </>
                ),
              },
              {
                title: (
                  <span className="breadcrumbcolor">{activeTabLabel}</span>
                ),
              },
            ]}
          />
        </Col>

        {isEdit() ? (
          <Col className="editTitle" offset={1} span={20}>
            {supplier?.name}
          </Col>
        ) : (
          <Col className="editTitle" offset={1} span={20}>
            {t("add-supplier")}
          </Col>
        )}

        <Row style={{ minHeight: "70vh" }}>
          <Col offset={1} span={22}>
            <Form
              onFinish={HandleFinish}
              layout="vertical"
              style={{ margin: "auto" }}
              form={form}
              id="supplierform"
              initialValues={{
                countryId: supplier?.country?.id,
                name: supplier?.name,
                abbreviation: supplier?.abbreviation,
                isActive: isEdit() ? supplier?.isActive : true,
                city: supplier?.city,
                postalCode: supplier?.postalCode,
                email: supplier?.email,
                phone: supplierPhoneNumber[1],
                phoneAreaCode: supplierPhoneNumber[0],
                mobile: supplierMobileNumber[1],
                mobileAreaCode: supplierMobileNumber[0],
                typeId: supplier?.type?.id,
                addressLine1: supplier?.addressLine1,
                addressLine2: supplier?.addressLine2,
                dob: isValid
                  ? supplier.dob
                  : dayjs().format("YYYY-MM-DD HH:mm:ss"),
                curId: supplier?.curr?.id,
                notes: supplier?.notes,
              }}
            >
              <Tabs
                className="ant-tab"
                defaultActiveKey="1"
                activeKey={key}
                items={items}
                onChange={onChange}
              />
            </Form>
          </Col>
        </Row>
        <Col offset={1} span={4}>
          <CancelBtn data-testid="cancel-button" />
        </Col>
        <Col
          offset={16}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <PreviousButton
            onClick={() => handlePrevious()}
            disabled={key === "1"}
            data-testid="previous-button"
          />
          {key !== "3" ? (
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              {key === "1" && (
                <NextButton
                  onClick={() => handleNext()}
                  disabled={!ContactType || !fullNameValid || !Currency}
                />
              )}
              {key === "2" && (
                <NextButton
                  onClick={() => handleNext()}
                  disabled={!isCountrySelected}
                />
              )}
            </Col>
          ) : (
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <AddEditButton
                onClick={() => {
                  setOpen(true);
                }}
                data-testid="add-button"
                disabled={""}
                isLoading={""}
              />
            </Col>
          )}
        </Col>
      </Row>
      <AddEditModal
        form="supplierform"
        open={open}
        setOpen={setOpen}
        name={<span> {supplier?.name}</span>}
        title={`${t("modal-supplier")}`}
        isSaving={isSaving}
      />
    </>
  );
}

export default AddEditSupplier;
